import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from 'wire-frame';

@Injectable({
  providedIn: 'root'
})
export class PharmacyService {

  constructor(private http: HttpClient, private common: CommonService) { }

  getPharmacyList() {
    // return this.http.get('/api/destinations');
    return this.http.get(this.common.getBaseUrl() + 'Pharmacy.php?action=getBooks');
  }

  addPharmacy(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addPharmacy";
    return this.http.post(this.common.getBaseUrl() + 'Pharmacy.php', payload);
  }

  updatePharmacy(payload: any) {
    payload["action"] = "updatePharmacy";
    return this.http.put(this.common.getBaseUrl() + 'Pharmacy.php', payload);
  }

  deletePharmacy(payload: any) {
    payload["action"] = "deletePharmacy";
    return this.http.put(this.common.getBaseUrl() + 'Pharmacy.php', payload);
  }
}
